// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__byFpU","empty":"ModalGraph_empty__29Jt4"};